import axios from 'Src/helpers/api/axiosInstance';
import { AppUser } from 'Src/views/App/App';

export interface UserSignature {
  _id: string;
  name: string;
  htmlContent: string;
  createdAt: string;
  updatedAt: string;
}

export function getUserSignatures(user: AppUser): Promise<UserSignature[]> {
  const { roleSessionKey: key, activeSchoolId } = user;
  return axios
    .get(`${window.apiBase}/i/schools/${activeSchoolId}/user-signatures`, {
      headers: { usid: key }
    })
    .then(r => r.data);
}

export function createUserSignature(
  user: AppUser,
  data: { name: string; htmlContent: string }
): Promise<UserSignature> {
  const { roleSessionKey: key, activeSchoolId } = user;
  return axios
    .post(`${window.apiBase}/i/schools/${activeSchoolId}/user-signatures`, data, {
      headers: { usid: key }
    })
    .then(r => r.data);
}

export function updateUserSignature(
  user: AppUser,
  id: string,
  data: { name?: string; htmlContent?: string }
): Promise<UserSignature> {
  const { roleSessionKey: key, activeSchoolId } = user;
  return axios
    .put(`${window.apiBase}/i/schools/${activeSchoolId}/user-signatures/${id}`, data, {
      headers: { usid: key }
    })
    .then(r => r.data);
}

export function deleteUserSignature(user: AppUser, id: string): Promise<void> {
  const { roleSessionKey: key, activeSchoolId } = user;
  return axios
    .delete(`${window.apiBase}/i/schools/${activeSchoolId}/user-signatures/${id}`, {
      headers: { usid: key }
    })
    .then(r => r.data);
}
